<template>
    <div class="container" style="height: 100%">
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
        <!-- 面包屑导航 -->
        <div class="content c-top">
            <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
            <el-table :row-style="{ height: '89px' }" :data="tableData" border :header-cell-style="{
                background: '#F5F6FA',
                textAlign: 'left',
                color: '#303033',
            }" style="width: 100%" :toggleRowExpansion="{ expanded: true }" ref="theTable">
                <el-table-column label="收货人姓名" prop="type" align="center">
                    <template slot="header">
                        <div style="display: flex">
                            <div style="line-height: 30px;"><span style="color:red">*</span>收货人姓名</div>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.name" placeholder="请输入收货人姓名">
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column label="收货人电话" prop="type" align="center">
                    <template slot="header">
                        <div style="display: flex">
                            <div style="line-height: 30px"><span style="color:red">*</span>收货人电话</div>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.phone" placeholder="请输入收货人电话" @blur="vaildPhone(scope.row.phone)"
                            :maxLength="11" oninput="value=value.replace(/[^0-9.]/g,'')">
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column label="收货人地址" prop="type" align="center">
                    <template slot="header">
                        <div style="display: flex">
                            <div style="line-height: 30px"><span style="color:red">*</span>收货人地址</div>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.address" placeholder="请输入收货地址">
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column label="操作" prop="remark" width="100">
                    <template slot-scope="scope">
                        <div style="color: #2D46EE;text-align: center;cursor: pointer;"
                            @click="deleteAddress(scope.$index)">删除
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="aBtn" @click="add">
                <img src="../../../assets/icon_add_16.png" style="width:16px;height:16px;margin-top:24px" />
                <div class="btn">添加地址</div>
            </div>
            <div class="bottom-box">
                <!-- <el-button type="warning" size="medium" style="width: 184px" @click="add">添加</el-button> -->

            </div>
        </div>
        <el-button type="primary" size="medium" style="width: 184px" @click="submit">保存</el-button>
    </div>
</template>
  
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
export default {
    watch: {
    },
    components: {
        breadcrumbTop,
        breadcrumbSearch
    },
    data() {
        return {
            searchList: {
                list: [
                    { title: '退货地址', path: '', type: '0' },
                    { title: '退货地址管理', path: '', type: '' }
                ]
            },
            dataList: {
                list: [
                    { title: '订单管理', path: '', type: '0' },
                    { title: '退货地址', path: '', type: '1' }
                ]
            },
            tableData: [

            ],
            dialogUser: false,
            loading: false,
            fileListImg: [], // 上传图片
            imageUrl: '',
            input1: '', //
            parArray: [], //
            lastTime: 0
            // tableData: [],
        }
    },
    mounted() {
    },
    created() {
        // this.getCommissionConfig()
        this.getList()
    },
    methods: {
        testPhone(str) {
            const reg = /^1[3|4|5|7|8|6|9][0-9]\d{8}$/;
            return reg.test(str);
        },
        vaildPhone(val) {
            console.log(val)
            if (!this.testPhone(val)) {
                this.$message.error('请输入正确手机号')
            }
        },
        getList() {
            this.axios.get('/orders/after/addressList')
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.tableData = res.data
                    }
                })
        },
        add() {
            let obj = {
                name: '',
                phone: '',
                address: ''
            }
            this.tableData.push(obj)
        },
        deleteAddress(index) {
            this.tableData.splice(index, 1)
        },
        submit() {
            this.axios.post('/orders/after/saveAddressList', this.tableData)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('保存成功')

                    }
                })

        },


    }
}
</script>
<style scoped lang="scss">
.aBtn {
    width: 100%;
    height: 64px;
    background: #FFFFFF;
    border: 1px solid #2D46EE;
    opacity: 1;
    border-radius: 0px;
    display: flex;
    justify-content: center;
    cursor: pointer;

    .btn {
        // width: 64px;
        height: 64px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 64px;
        color: #2D46EE;
        opacity: 1;
    }
}

/deep/ .el-table {
    tr th,
    tr td {
        border-right: none;
    }
}

.el-table td,
.el-table th[data-v-372de25b] {
    text-align: left !important;
}

::v-deep.el-table td {
    text-align: left !important;
}

.bottom-box {
    width: 100%;
    height: 24px;
    border-top: 1px solid #ebebfa;
    display: flex;
    align-items: center;
    justify-content: center;

}
</style>
  